import { NCTokenType } from '@components/common/NCFile/types';

export const NC_FILE_TOOL_CALL_HEADER_HEIGHT = 42;
export const SCROLL_TOP_THRESHOLD = 300;

export const TOKEN_COLOR_MAP: Record<NCTokenType, string> = {
  [NCTokenType.DEFAULT]: 'Label/Light/Primary',
  [NCTokenType.LINE_NUMBER]: 'NC-Color/Light/Line number',
  [NCTokenType.VALUE]: 'NC-Color/Light/Value',
  [NCTokenType.COMMENT]: 'NC-Color/Light/Comment',
  [NCTokenType.FMAX]: 'NC-Color/Light/FMAX',
};
